exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{margin:0;padding:0}a{outline:none;text-decoration:none}body{font-family:roboto,\"sans serif\",ubuntu,arial}.container,.container_flex{display:block;width:100%;max-width:1280px;min-width:320px;margin:0 auto;position:relative}.container_flex{display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start}ul{list-style:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-170146d6","scoped":false,"hasInlineConfig":false}!./~/autoprefixer-loader!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/App.vue
// module id = 36
// module chunks = 0